import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../components/loading";
import Typography from "../../components/typography";
import { axiosAuthedInstance, axiosInstance } from "../../utils/axiosApi";
import {isLoggedIn} from "../../utils/auth";
import ErrorPage from "../../components/error_page";
import ClinicLookup from "../../components/clinic_lookup";
import { BaseContainer } from "../../components/container";
import { HeaderTitle } from "../../components/page_sections";
import { Button } from "../../components/button";
import config from "../../config";

const VerifyShare = (props) => {
    const token = props.match.params.token
    // When accounts are clinic-managed, patients can't self sign up, so an
    // unauthenticated recipient is shown a landing page instead of onboarding.
    const clinicLanding = config.clinicManagedAccounts && !isLoggedIn()
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [expired, setExpired] = useState(false)
    const [showLanding, setShowLanding] = useState(false)
    const history = useHistory();

    function handleOpenError(error) {
        console.warn(error)
        if (error.response?.data) {
            setError(error.response.data.error)
            setExpired(error.response.status === 400)
        } else {
            setError('There was an error with the request. Please try again later and make sure the url is correct.')
        }
        setLoading(false)
    }

    function openSharingInvite() {
        axiosInstance.post(
            `/user/open-sharing-invite/${token}/`
        ).then(() => {
            // The invite is now opened (opened_at is set). This is required for
            // post-signup-login to find it after the user logs in, so we open it
            // here even for the clinic-managed landing page.
            if (clinicLanding) {
                setShowLanding(true)
                setLoading(false)
                return
            }
            if (isLoggedIn()) {
                // This sets recipient of SharingInvite to current user
                // redirects to home as user is already logged-in
                axiosAuthedInstance.post(
                    'user/invite/post-signup-login/',
                    { token }
                ).then(result => {
                    if (result.data.data.error) {
                        history.push('/invite/error', {type: "sharing", error: result.data.data.error})
                    } else {
                        history.push('/sharing/confirm', {token})
                    }
                }).catch(err => {
                    console.error(err)
                    let msg = 'There was an error with the request. Please try again later and make sure the url is correct'
                    if (err.response?.data?.error) {
                        msg = err.response.data.error
                    }
                    setError(msg)
                    setLoading(false)
                })
            } else {
                history.push('/', { token, type: 'sharing' })
            }
        }).catch(handleOpenError)
    }

    useEffect(() => {
        openSharingInvite();
    }, []);

    if (loading) {
        return (
            <Loading loading={loading}/>
        )
    }

    if (showLanding) {
        return (
            <BaseContainer {...props} noHeader>
                <HeaderTitle>Accept sharing invite</HeaderTitle>
                <Typography variant="bodyTextMedium" style={{ lineHeight: 1.6 }}>
                    If you have an Imunis account, login here:
                </Typography>
                <Button
                    primary
                    fullWidth
                    style={{ marginTop: 16, marginBottom: 24 }}
                    onClick={() => history.push('/login', { token, type: 'sharing' })}
                >
                    Login
                </Button>
                <Typography variant="bodyTextMedium" style={{ lineHeight: 1.6 }}>
                    If you are not registered with Imunis, you may register via one of the health providers below.
                </Typography>
                <ClinicLookup />
            </BaseContainer>
        )
    }

    if (error){
        return (
            <ErrorPage
                expired
                title={expired ? 'Sorry, this email link has expired' : 'Could not open sharing invite'}
                content={error}
                location={'/'}
                cta_label={"Go to homepage"}
            />
        )
    }
    return null
}
export default VerifyShare;
